import React from 'react';
import { Route, Switch } from 'react-router-dom';
import page404 from 'containers/Page/404';
import Profile from './profile';
import FamilyTree from './familyTree';
import FamilyTreeRequests from './familyTree/FamilyTreeRequests';
import MembershipPlanPage from './membership';

const routes = [
  {
    path: 'profile',
    component: Profile,
    exact: true,
  },
  {
    path: 'membership',
    component: MembershipPlanPage,
    exact: true,
  },
  {
    path: 'family-tree/:id/requests',
    component: FamilyTreeRequests,
    exact: true,
  },
  {
    path: 'family-tree/:id',
    component: FamilyTree,
    exact: true,
  },
];

interface AccountRouterProps {
  url: string;
}

const AccountRouter = ({ url }: AccountRouterProps) => {
  return (
    <Switch>
      {routes.map((singleRoute) => {
        const { path, exact, ...otherProps } = singleRoute;
        return <Route exact={!!exact} key={path} path={`${url}/${path}`} {...otherProps} />;
      })}
      <Route
        component={page404} // if no page matched
      />
    </Switch>
  );
};

export default AccountRouter;
